<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">企业名称:</span>

                        <el-select
                            v-model="top_store_code"
                            placeholder="请选择企业名称"
                            @visible-change="getStoreFirst"
                            @change="qiyeChange"
                            clearable
                            @keyup.enter.native="searchExportStoreOrderLists"
                            style="width: 300px"
                        >
                            <el-option
                                v-for="item in options_qiye_code"
                                :key="item.top_store_code"
                                :label="item.name"
                                :value="item.top_store_code"
                            >
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">门店名称:</span>

                        <el-select
                            v-model="search_data.store_code"
                            placeholder="请选择门店名称"
                            @visible-change="getStoreSecond"
                            @change="mendianChange"
                            clearable
                            @keyup.enter.native="searchExportStoreOrderLists"
                            style="width: 300px"
                        >
                            <el-option
                                v-for="item in options_mendian_code"
                                :key="item.store_code"
                                :label="item.name"
                                :value="item.store_code"
                            >
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchExportStoreOrderLists">搜索</el-button>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

            <el-button :icon="!progress_show ? 'el-icon-setting' : 'el-icon-loading'" @click="toExport" :disabled="progress_show">{{
                progress_show ? '正在导出...' : '导出'
            }}</el-button>
            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div style="width: 830px; display: flex">
                            <div style="width: 100px">上传图片:</div>
                            <div>
                                <el-image
                                    v-for="(item, index) in props.row.order_img"
                                    :key="index"
                                    style="width: 100px; height: 100px; display: inline-block"
                                    :src="item"
                                    :preview-src-list="order_img"
                                >
                                </el-image>
                            </div>
                        </div>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column label="订单编码" prop="order_code" min-width="90px"> </el-table-column>

            <el-table-column label="下单人姓名" prop="create_order_username" min-width="80px"> </el-table-column>

            <el-table-column label="订单金额" prop="amount" min-width="70px"> </el-table-column>

            <el-table-column label="下单时间" prop="order_time_stamp" min-width="90px"> </el-table-column>

            <el-table-column label="初始地" prop="start_name" min-width="100px"> </el-table-column>

            <el-table-column label="目的地" prop="end_name" min-width="100px"> </el-table-column>
            <el-table-column label="车牌号" prop="plate" min-width="90px"> </el-table-column>
            <el-table-column label="备注" prop="remarks" min-width="90px"> </el-table-column>
            <el-table-column label="总距离" prop="on_way_distance" min-width="60px"> </el-table-column>
            <el-table-column label="等待时长" prop="wait_duration" min-width="70px"> </el-table-column>
            <el-table-column label="等待金额" prop="wait_amount" min-width="70px"> </el-table-column>
            <el-table-column label="耗时金额" prop="duration_amount" min-width="70px"> </el-table-column>
            <el-table-column label="总时长" prop="on_way_duration" min-width="60px"> </el-table-column>
            <el-table-column label="圈内时长" prop="free_area_duration" min-width="70px"> </el-table-column>
            <el-table-column label="权益金额" prop="order_equity" min-width="70px"> </el-table-column>
            <el-table-column label="车架号" prop="vin_no" min-width="90px"> </el-table-column>
            <el-table-column label="取车电话" prop="get_phone" min-width="70px"> </el-table-column>
            <el-table-column label="送车电话" prop="send_phone" min-width="70px"> </el-table-column>
            <el-table-column label="司机姓名" prop="driver_name" min-width="70px"> </el-table-column>
            <el-table-column label="司机电话" prop="driver_phone" min-width="70px"> </el-table-column>
            <!-- <el-table-column label="上传图片" prop="order_img" min-width="90px"> </el-table-column> -->
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

<script>
var _this;
import table2excel from 'js-table2excel';
export default {
    data() {
        return {
            maxLength: 0,
            column: [],
            order_img: [], //展开行里面的图片
            excelName: '店铺订单导出',
            tableDataCount: 0, //导出数据的数量
            search_time: '',
            top_store_code: '',
            loading: false,
            progress_show: false,
            progress_data: 0,
            excelData: [],
            excelHead: [],

            value_mendian_code: '',
            value_qiye_code: '',
            options_mendian_code: [],
            options_qiye_code: [],

            // 存放表格数据
            tableData: [],
            tableExportData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                store_code: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        getStoreSecond(val) {
            if (val) {
                if (_this.top_store_code == '') {
                    this.$message.error('请先选择企业');
                } else {
                    _this
                        .$post('/store/getStoreSecond', { top_store_code: _this.top_store_code })
                        .then((res) => {
                            _this.options_mendian_code = res.data;
                        })
                        .catch((err) => {});
                }
            }
        },

        getStoreFirst() {
            if (_this.options_qiye_code.length == 0) {
                _this
                    .$post('/store/getStoreFirst')
                    .then((res) => {
                        _this.options_qiye_code = res.data;
                    })
                    .catch((err) => {});
            }
        },

        mendianChange(val) {
            _this.search_data.store_code = val;
            _this.searchExportStoreOrderLists();
        },
        qiyeChange(val) {
            _this.options_mendian_code = []; //选择企业，门店下拉列表绑定值要清空
            _this.search_data.store_code = ''; //选择企业，门店编码
            _this.top_store_code = val; //企业下拉列表绑定值，根据该值去获取对应企业下所属门店
        },

        timeChange(val) {

            if (val != null) {
                // _this.search_data.date_time = JSON.stringify(['between', ..._this.search_time]);
                // _this.search_data.date_time = JSON.stringify(_this.search_time);
                _this.search_data.date_time = _this.search_time;
            } else {
                _this.search_data.date_time = '';
            }
        },

        searchExportStoreOrderLists() {

            _this.search_data.page = 1;
            _this.exportStoreOrderLists();
        },

        exportStoreOrderLists() {

            if (_this.top_store_code == '') {
                this.$message.error('请选择企业');
            } else if (_this.search_data.store_code == '') {
                this.$message.error('请选择门店');
            } else {
                return new Promise((resolve, reject) => {
                    _this
                        .$post('/store/exportStoreOrderLists', _this.search_data, _this.search_rules)
                        .then((res) => {
                            // 将请求的数据存放到表格数据数组中
                            _this.tableData = res.data.list;
                            _this.result_data = res.data;

                            _this.tableDataCount = res.data.count; //导出数据的数量，用于导出

                            _this.order_img = []; //展开行里面的上传图片
                            for (let i = 0; i < _this.tableData.length; i++) {
                                for (let j = 0; j < _this.tableData[i].order_img.length; j++) {
                                    _this.order_img.push(_this.tableData[i].order_img[j]);
                                    //列表展开行里面的图片预览
                                }
                            }

                            resolve();
                        })
                        .catch((err) => {});
                });
            }
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.exportStoreOrderLists();
        },

        toExport() {
            _this.search_data.page = 1;
            _this.search_data.limit = 10;

            _this.column = [
                {
                    title: '订单编码',
                    key: 'order_code',
                    type: 'text'
                },
                {
                    title: '下单人姓名',
                    key: 'create_order_username',
                    type: 'text'
                },
                {
                    title: '订单金额',
                    key: 'amount',
                    type: 'text'
                },
                {
                    title: '下单时间',
                    key: 'order_time_stamp',
                    type: 'text'
                },
                {
                    title: '初始地',
                    key: 'start_name',
                    type: 'text'
                },
                {
                    title: '目的地',
                    key: 'end_name',
                    type: 'text'
                },
                {
                    title: '车牌号',
                    key: 'plate',
                    type: 'text'
                },
                {
                    title: '备注',
                    key: 'remarks',
                    type: 'text'
                },
                {
                    title: '总距离',
                    key: 'on_way_distance',
                    type: 'text'
                },
                {
                    title: '等待时长',
                    key: 'wait_duration',
                    type: 'text'
                },
                {
                    title: '等待金额',
                    key: 'wait_amount',
                    type: 'text'
                },
                {
                    title: '耗时金额',
                    key: 'duration_amount',
                    type: 'text'
                },
                {
                    title: '总时长',
                    key: 'on_way_duration',
                    type: 'text'
                },
                {
                    title: '圈内时长',
                    key: 'free_area_duration',
                    type: 'text'
                },
                {
                    title: '权益金额',
                    key: 'order_equity',
                    type: 'text'
                },
                {
                    title: '车架号',
                    key: 'vin_no',
                    type: 'text'
                },
                {
                    title: '取车电话',
                    key: 'get_phone',
                    type: 'text'
                },
                {
                    title: '送车电话',
                    key: 'send_phone',
                    type: 'text'
                },
                {
                    title: '司机姓名',
                    key: 'driver_name',
                    type: 'text'
                },
                {
                    title: '司机电话',
                    key: 'driver_phone',
                    type: 'text'
                }
                // {
                //     title: '上传图片',
                //     key: 'order_img',
                //     type: 'image',
                //     width: 100,
                //     height: 100
                // }
            ];

            _this.getExcelData();
        },

        getExcelData() {

            _this.exportStoreOrderLists().then(() => {

                for (let i = 0; i < _this.tableData.length; i++) {

                    _this.tableExportData.push({
                        order_code: _this.tableData[i].order_code,
                        create_order_username: _this.tableData[i].create_order_username,
                        amount: _this.tableData[i].amount,
                        order_time_stamp: _this.tableData[i].order_time_stamp,
                        start_name: _this.tableData[i].start_name,
                        end_name: _this.tableData[i].end_name,
                        plate: _this.tableData[i].plate,
                        remarks: _this.tableData[i].remarks,
                        on_way_distance: _this.tableData[i].on_way_distance,
                        wait_duration: _this.tableData[i].wait_duration,
                        wait_amount: _this.tableData[i].wait_amount,
                        duration_amount: _this.tableData[i].duration_amount,
                        on_way_duration: _this.tableData[i].on_way_duration,
                        free_area_duration: _this.tableData[i].free_area_duration,
                        order_equity: _this.tableData[i].order_equity,
                        vin_no: _this.tableData[i].vin_no + '&nbsp',
                        get_phone: _this.tableData[i].get_phone,
                        send_phone: _this.tableData[i].send_phone,
                        driver_name:_this.tableData[i].driver_name,
                        driver_phone:_this.tableData[i].driver_phone
                        // order_img: _this.tableData[i].order_img
                    });


                    if (_this.tableData[i].order_img.length > 0) {

                        for (let j = 0; j < _this.tableData[i].order_img.length; j++) {
                            // _this.tableExportData[i]['order_img' + j] = _this.tableData[i].order_img[j];这样写完如果数据多于2页，导出数据就不对劲
                            _this.tableExportData[_this.search_data.page*_this.search_data.limit-_this.search_data.limit+i]['order_img' + j] = _this.tableData[i].order_img[j];



                        }
                    }


                    if (_this.tableData[i].order_img.length > _this.maxLength) {
                        _this.maxLength = _this.tableData[i].order_img.length;

                    }
                }

                if (_this.search_data.page * _this.search_data.limit < _this.tableDataCount) {
                    _this.search_data.page = _this.search_data.page + 1;
                    _this.progress_data = Math.floor(((_this.search_data.page * _this.search_data.limit) / _this.tableDataCount) * 100);
                    _this.getExcelData();
                } else {
                    for (let index = 0; index < this.maxLength; index++) {
                    _this.column.push({
                        title: '上传图片' + index,
                        key: 'order_img' + index,
                        type: 'image',
                        width: 100,
                        height: 100
                    });
                }
                    table2excel(_this.column, _this.tableExportData, _this.excelName); //生成Excel表格，自动下载
                    _this.searchExportStoreOrderLists();

                    // 清空数据
                    _this.tableExportData = [];
                    _this.maxLength = 0;
                    _this.tableDataCount = 0;
                    _this.column = [
                        {
                            title: '订单编码',
                            key: 'order_code',
                            type: 'text'
                        },
                        {
                            title: '下单人姓名',
                            key: 'create_order_username',
                            type: 'text'
                        },
                        {
                            title: '订单金额',
                            key: 'amount',
                            type: 'text'
                        },
                        {
                            title: '下单时间',
                            key: 'order_time_stamp',
                            type: 'text'
                        },
                        {
                            title: '初始地',
                            key: 'start_name',
                            type: 'text'
                        },
                        {
                            title: '目的地',
                            key: 'end_name',
                            type: 'text'
                        },
                        {
                            title: '车牌号',
                            key: 'plate',
                            type: 'text'
                        },
                        {
                            title: '备注',
                            key: 'remarks',
                            type: 'text'
                        },
                        {
                            title: '总距离',
                            key: 'on_way_distance',
                            type: 'text'
                        },
                        {
                            title: '等待时长',
                            key: 'wait_duration',
                            type: 'text'
                        },
                        {
                            title: '等待金额',
                            key: 'wait_amount',
                            type: 'text'
                        },
                        {
                            title: '耗时金额',
                            key: 'duration_amount',
                            type: 'text'
                        },
                        {
                            title: '总时长',
                            key: 'on_way_duration',
                            type: 'text'
                        },
                        {
                            title: '圈内时长',
                            key: 'free_area_duration',
                            type: 'text'
                        },
                        {
                            title: '权益金额',
                            key: 'order_equity',
                            type: 'text'
                        },
                        {
                            title: '车架号',
                            key: 'vin_no',
                            type: 'text'
                        },
                        {
                            title: '取车电话',
                            key: 'get_phone',
                            type: 'text'
                        },
                        {
                            title: '送车电话',
                            key: 'send_phone',
                            type: 'text'
                        },
                        {
                            title: '司机姓名',
                            key: 'driver_name',
                            type: 'text'
                        },
                        {
                            title: '司机电话',
                            key: 'driver_phone',
                            type: 'text'
                        }
                        // {
                        //     title: '上传图片',
                        //     key: 'order_img',
                        //     type: 'image',
                        //     width: 100,
                        //     height: 100
                        // }
                    ];

                    _this.progress_show = false;
                    _this.progress_data = 0;

                }
            });
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>

